import './modules/_lazysizes.js'

document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.wrapper')
    if (wrapper.classList.contains('wrapper--home')) require('./modules/_home.js')
    else if (wrapper.classList.contains('wrapper--projects-index')) require('./modules/_projects-index.js')

    window.addEventListener('keydown', e => {
        if (e.key === ';') document.body.classList.toggle('debug')
    })
})
